<template>


<!--    TODO:place excluded products switch button somewhere here-->


    <div class="row">
        <SearchBar
                :searchOptions="pricesModule.getPricesProductsAvailableSearchOptions"
                @searchAndFilterRequest="searchOnList($event)"
        />
    </div>

    <div v-if="refreshTable" class="row">
        <CommonTable2
                :table="tableData"
                @onItemAction="runTableAction($event)"
                @onSort="sort($event)"
                @onMassAction="runMassAction($event)"
                @onCheckItem="checkAction($event)"
                :sortColumn="sortingKey"
                :sortDirection="sortingDirection"
        />

    </div>


    <b-pagination
            v-model="currentPage"
            size="lg"
            :total-rows="pricesModule.getPricesProductsTotal"
            :per-page="50"
            aria-controls="prices-products-table"
    ></b-pagination>

</template>

<script>
import SearchBar from "@/components/widgets/SearchBar.vue";

import {priceProductsTableStructure} from "./data/priceProductsTableStructure";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import swal from "sweetalert2";
import {log} from "@/state/pinia/log";
import {usePricesManagerModule} from "@/state/pinia/pricesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
    name: "PricesProductsStage",
    components: {CommonTable2, SearchBar},
    data() {
        return {
            showExcludedProducts: false,
            currentTaskId: null,
            currentPage: 1,
            sortingDirection: "ASC",
            sortingKey: "name",
            searchAndFilterRequest: {
                searchPhrase: "",
                type: 0,
            },
            pricesProductItems: [],
            tableHeaders: priceProductsTableStructure.headers,
            tableMassActions: priceProductsTableStructure.massActions,
            tableData: {},
            refreshTable:true //TODO: added key to force re-rendering
        }
    },
    computed: {
      pricesModule(){
        return usePricesManagerModule();
      },

      simplepharmAuth(){
        return useSimplepharmAuthModule();
      },
      commonModule(){
        return useCommonAppModule();
      },
      lazyloaderModule(){
        return useLazyLoaderModule();
      },
    },
    methods: {

        searchOnList(searchAndFilterRequest) {
            this.searchAndFilterRequest = searchAndFilterRequest;
            this.refreshPricesProductsList();
        },
        toggleSortingDirection() {
            if (this.sortingDirection === "ASC") {
                this.sortingDirection = "DESC";
            } else {
                this.sortingDirection = "ASC";
            }
        },
        toggleExcludedFlag() {
            this.showExcludedProducts = this.showExcludedProducts !== true;
        },
        runTableAction(action) {
            if (action.action === "delete") {
                if(action.itemData.isStatic === false){
                    this.showDeleteNotAllowedWarning();
                }else{
                    this.showDeleteProductConfirmation(action.itemData);
                }
            }
        },
        showDeleteProductConfirmation(product) {
            swal({
                title: "Usunąć product?",
                text: "Czy na pewno usunąć " + product.name +" ze strategii?. Operacja jest nieodwracalna!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                    if (willDelete) {
                        var payload = {
                            centralId: product.centralId
                        };
                        this.pricesModule.httpRemoveProduct(payload).then(() => {
                            this.refreshPricesProductsList();
                        });
                    } else {

                        // Do nothing...
                    }
                }
            )
            ;
        },
        showDeleteNotAllowedWarning(){
            swal.fire({
                title: "Usuniecie niedozwolone",
                text: "Nie można usunąć produktu, który nie jest statyczny.",
                type: "warning",
                confirmButtonText: "Ok",
            });
        },
        sort(sortingKeyValue) {
            this.sortingKey = sortingKeyValue;
            this.toggleSortingDirection();
            this.refreshPricesProductsList();
        },
        runMassAction(action) {
          log.log(action);
            // no mass actions for this table
        },
        checkAction(event) {
            log.log(event);
            // no check actions for this table
        },
        showExcludedProductsList() {
            this.toggleExcludedFlag();
            this.refreshPricesProductsList();
        },
        refreshPricesProductsList() {
            this.pricesModule.setPricesProducts([])
            this.currentTaskId = this.$route.params.taskId;
            var payload = {
                searchAndFilterRequest: this.searchAndFilterRequest,
                currentPage: this.currentPage,
                excluded: this.showExcludedProducts,
                taskCentralId: this.currentTaskId,
                sortingDirection: this.sortingDirection,
                sortingKey: this.sortingKey,
            };
          this.refreshTable = false;
            this.pricesModule.httpGetPricesProductsPaging(payload).then(() => {
                this.pricesProductItems = JSON.parse(JSON.stringify(this.pricesModule.getPricesProducts));
                this.tableData['data'] = this.pricesProductItems;
                this.refreshTable = true;
            });
        }
    },
    watch: {
        currentPage: {
            handler() {
                this.refreshPricesProductsList();
            },
            deep: true,
        },

    },
    created() {
      this.pricesProductItems = JSON.parse(JSON.stringify(this.pricesModule.getPricesProducts));
      this.tableData['headers'] = this.tableHeaders;
      this.tableData['massActions'] = this.tableMassActions;

      this.simplepharmAuth.refreshToken().then(() => {
        this.commonModule.httpGetLicensedFeatures();
        this.commonModule.httpGetWorkingProfile().then(() => {
          this.refreshPricesProductsList();
        });
      });
    },
}
</script>

<style scoped>

</style>
